import Compressor from 'compressorjs'
import _ from 'lodash'

function compressImage(image, settings = {}) {
  const defaultSettings = (resolve, reject) => {
    return {
      checkOrientation: false,
      convertSize: 2000000,
      maxWidth: 4096, // as per docs recommendation
      maxHeight: 4096, // as per docs recommendation
      success(result) {
        resolve(result)
      },
      error(err) {
        reject(err)
      }
    }
  }

  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-new
    new Compressor(image, _.merge(defaultSettings(resolve, reject), settings))
  })
}

async function compress(files, settings = {}) {
  const compressedImages = _.map(files, file => compressImage(file, settings))
  const result = await Promise.all(compressedImages)
  return result
}

export default {
  compress
}
